module.exports = __webpack_public_path__ + "img/blutuz.dfcbbd21.svg";